import RightTimeApi from "@/API";

export type CompanyBillingSettings = {
    billingEmail?: string | null;
};

function normalizeBillingSettings(raw: Record<string, unknown> | null | undefined): CompanyBillingSettings {
    return {
        billingEmail: (raw?.billingEmail ?? raw?.BillingEmail ?? "") as string,
    };
}

export async function loadBillingSettingsAsync(companyId: number): Promise<CompanyBillingSettings | null> {
    const resp = await RightTimeApi.getAsync(`/Company/${companyId}/BillingSettings`);
    if (resp?.ok && resp.jsonData) {
        return normalizeBillingSettings(resp.jsonData);
    }
    return null;
}

export async function saveBillingSettingsAsync(companyId: number, settings: CompanyBillingSettings) {
    return RightTimeApi.putAsync(`/Company/${companyId}/BillingSettings`, {
        billingEmail: settings.billingEmail || null,
    });
}
